export default {
    meetingNoteList: (state, getters, rootState, rootGetters) => {
        return state.meetingNoteList;
    },
    meetingNote: (state, getters, rootState, rootGetters) => ({meetingNoteId}) => {
        if(!meetingNoteId) return;
        return state.meetingNoteList.find(note => note.meetingNoteId === meetingNoteId);
    },
    ongoingMeetingNote: (state, getters, rootState, rootGetters) => {
        return state.meetingNoteList.find(note => !note.endDate);
    },
    isOngoingMeetingNote: (state, getters, rootState, rootGetters) => {
        return !!getters.ongoingMeetingNote;
    },
    summaryState: (state, getters, rootState, rootGetters) => {
        return !!getters.ongoingMeetingNote;
    },
    writingTime: (state, getters, rootState, rootGetters) => {
        return state.writingTime || 0;
    },
    findMeetingNote: (state, getters, rootState, rootGetters) => ({meetingNoteId}) => {
        if(!meetingNoteId) return;
        return state.meetingNoteList.find(note => note.meetingNoteId === meetingNoteId);
    },
}
